import { render, staticRenderFns } from "./TransferenciaMatrizEFilial.vue?vue&type=template&id=5f09c5c4"
import script from "./TransferenciaMatrizEFilial.vue?vue&type=script&lang=js"
export * from "./TransferenciaMatrizEFilial.vue?vue&type=script&lang=js"
import style0 from "./TransferenciaMatrizEFilial.vue?vue&type=style&index=0&id=5f09c5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports